import ApiService from "../api";

const firstCheck = "Estou ciente da regra da tarifa e que o reembolso será recusado caso a reserva não esteja cancelada.";   

const secondCheck = "Reembolso dentro das 24h após emissão com embarque superior a 7 dias ou que tenha restrição na regra da tarifa " + 
"para solicitação antes da data do embarque deverão ser obrigatoriamente encaminhados para e-mail reembolso24h@grupobrt.com.br após abertura da solicitação."

class ReembolsoService extends ApiService {

    static get firstCheck(){
        return firstCheck;
    }

    static get secondCheck(){
        return secondCheck;
    }

    constructor(){
        super('/portal/solicitacao')
    }

    salvar(solicitacao){
        return this.post('/saveSolicitacao', solicitacao)
    }

    listar(filtro){
        return this.post('/listarSolicitacoes', filtro)
    }

    enviarEmails(solicitacoes){
        return this.post('/sendEmail', solicitacoes)
    }

    pegarUsuarioSolicitacao(codemp){
        return this.post("/userSolicitacao", codemp)
    }
}

export default ReembolsoService;